import { Injectable } from '@angular/core';
import moment from 'moment';
import { StartEnd } from '../models/start-end.mode';

@Injectable({
    providedIn: 'root'
})
export class DateHandlingService {
    constructor() {}

    getMonthStartAndEndDates(date: Date): StartEnd {
        const startOfMonth = moment(date).startOf('month').format('YYYY-MM-DD');
        const endOfMonth = moment(date).endOf('month').format('YYYY-MM-DD');
        const dates = { start: startOfMonth, end: endOfMonth };
        return dates;
    }
    
    getDateByYearsAndMonths(dateRange: string, date: StartEnd) {
        const startDate = moment(date.start);
        const endDate = moment(date.end);
        const monthsOrYears = [];
        while ( startDate <= endDate ) {
            monthsOrYears.push({date: startDate.format(dateRange === 'monthly' ? 'YYYY-MM' : 'YYYY')});
            if ( dateRange === 'yearly' ) { startDate.set('month', 0) }
            startDate.add(1, dateRange === 'monthly' ? 'months' : 'years');
        }
        return monthsOrYears;
    }

    formatDate(date, format) {
        return moment(date).format(format);
    }
    
}
